import axios from 'axios';
import localStorage from '../helpers/localStorage';

/**
 * Format a date to english format
 *
 * @param date - moment instance
 * @returns {*}
 */
const englishFormat = (date) => date.format('YYYY-MM-DD');

const request = (method, uri, data) => new Promise((resolve, reject) => {
    const config = method === 'get' ? {
        params: data
    } : data;

    axios[method](uri, config)
        .then(response => resolve(response.data))
        .catch(error => {
        const e = {
                config: error.config,
                message: error.message,
                request: error.request,
                response: error.response ? error.response : {}
            };
            reject(e)
        });
});

const toUrl = (url) => `${process.env.ENDPOINT_BASE_URL}/${url}/`;

const urls = {
    flex: {
        get: toUrl('catalog/ticket/products')
    },
    fix: {
        get: (duration) => toUrl(`catalog/ticket/products/fix/${duration}`)
    },
    cart: {
        get: (id) => toUrl(`store/cart/${id}`),
        update: (id) => toUrl(id ? `store/cart/${id}` : 'store/cart')
    },
    card: {
        get: (id) => toUrl(`store/cart/check_card/${id}`)
    },
    order: {
        email: {
            post: (orderId) => toUrl(`store/customer/orders/${orderId}/email`)
        }
    },
    passes_cart: {
        get_cart: {
            post: toUrl(`passes/get_cart`)
        }
    },
    passes: {
        customer: {
            get: toUrl(`passes/pass/customer`)
        }
    },
    stock_date: {
        get: toUrl(`store/stock_date`)
    },
    card_products: {
        post: toUrl(`store/card_info`)
    },
    health: {
        post: toUrl(`store/health`)
    }
};

export default {
    flex: {
        get: (params) => request('get', urls.flex.get, params)
    },

    fix: {
        get: ({
            duration,
            startDate,
            endDate
        }) => request('get', urls.fix.get(duration), {
            startDate: englishFormat(startDate),
            endDate: englishFormat(endDate)
        })
    },

    cart: {
        get: ({
            id
        }) => {
            if (!id) return {
                products: []
            };

            return request('get', urls.cart.get(id))
        },

        update: (cart) => {
            const {
                id
            } = localStorage.get('cart');

            return request(id ? 'put' : 'post', urls.cart.update(id), {
                products: cart
            });
        }
    },

    card: {
        get: ({
            id
        }) => request('get', urls.card.get(id))
    },

    order: {
        email: {
            post: ({
                orderId,
                email
            }) => request('post', urls.order.email.post(orderId), {
                email
            })
        }
    },

    passes: {
        update: {
            post: (params) => {
                const {
                    uuid
                } = localStorage.get('passes_cart');
                return request('post', urls.passes_cart.update.post, {
                    cart: params,
                    cart_id: uuid
                })
            }
        },
        get_cart: {
            post: (params) => {
                const uuid = window.localStorage.getItem('passes_cart');
                return request('post', urls.passes_cart.get_cart.post, {
                    cart: uuid
                })
            }
        },
        customer: {
            get: ({rut}) => request('get', urls.passes.customer, {"rut": rut})
        },
    },
    stock_date: {
        get: (params) => request('get', urls.stock_date.get)
    },
    card_products: {
        post: ({wtp_number}) => request('post', urls.card_products.post, {wtp_number: wtp_number})
    },
    health_form: {
        post: ({
            date_attendance,
            names,
            last_names,
            document_number,
            telephone,
            email,
            symptom_check,
            contact_check,
            commune_check,
            attest_check,
            product_name,
            order_id
        }) => request('post', urls.health.post, {
            date_attendance: date_attendance,
            names: names,
            last_names: last_names,
            document_number: document_number,
            telephone: telephone,
            email: email,
            symptom_check: symptom_check,
            contact_check: contact_check,
            commune_check: commune_check,
            attest_check: attest_check,
            product_type: product_name,
            order_id: order_id
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/index.js